// extracted by mini-css-extract-plugin
module.exports = {"container":"ProfileDpdAccount_container__31Kj1","profile-item":"ProfileDpdAccount_profile-item__2efmb","account-number":"ProfileDpdAccount_account-number__qFpEX"};